import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;

export const expert={
    detail: rootPath +"/project/review/expert/detail",
    save : rootPath +"/project/review/expert/save",
    genFile: rootPath +"/project/review/expert/genApplyPDF",
    audit : rootPath +"/project/review/expert/audit",
    current: rootPath +"/project/review/expert/current",
}

export const govInstitution={
    detail: rootPath +"/project/review/govInstitution/detail",
    save : rootPath +"/project/review/govInstitution/save"
}

export const application = {
    pageList: rootPath +"/project/review/page",
    save: rootPath +"/project/review/save",
    delete: rootPath +"/project/review/del",
    submit: rootPath +"/project/review/submit",
    audit: rootPath +"/project/review/audit",
    result: rootPath +"/project/review/result",
    detail: rootPath +"/project/review/detail",
    myPageList: rootPath +"/project/review/my",
    appendAudit: rootPath +"/project/review/append",
    myAppendAudit: rootPath +"/project/review/myAppendAudit",
    noCheckAppendFile: rootPath +"/project/review/noCheckAppend"
}

export const applicationIndex = {
    pageList: rootPath +"/web/project/review/index/page",
  notLoginPage: rootPath +"/web/project/review/index/notLoginPage",
    detail: rootPath +"/web/project/review/index/detail",
  notLoginDetail: rootPath +"/web/project/review/index/notLoginDetail",
    download: rootPath +"/web/project/review/index/download",
}

export const registered = {
    my: rootPath+"/project/review/registered/my",
    reg: rootPath +"/project/review/registered/reg",
    unReg: rootPath +"/project/review/registered/unReg",
    checkRole: rootPath +"/project/review/registered/checkRole",
    isReg: rootPath +"/project/review/registered/isReg",
    read: rootPath +"/project/review/registered/readFile"
}

export const confirm ={
    save: rootPath +"/project/review/confirm/save",
    list: rootPath +"/project/review/confirm/list",
    batch: rootPath +"/project/review/confirm/batch",
    other: rootPath +"/project/review/confirm/other"
}

export const expert_file={
    save: rootPath +"/project/review/expert-file/save",
    delete: rootPath +"/project/review/expert-file/delete",
    getOtherByExpert: rootPath +"/project/review/expert-file/getOtherByExpert",
    getTitleByExpert: rootPath +"/project/review/expert-file/getTitleByExpert",
}
